import { observable } from "mobx";
import { Type } from "class-transformer";
import OpeningHoursIntervalResponse from "./openingHoursIntervalResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OpeningHoursWeekResponse {
  /**
   * The list of opening hours for Monday.
   */
  @observable
  @Type(() => OpeningHoursIntervalResponse)
  monday?: OpeningHoursIntervalResponse[];

  /**
   * The list of opening hours for Tuesday.
   */
  @observable
  @Type(() => OpeningHoursIntervalResponse)
  tuesday?: OpeningHoursIntervalResponse[];

  /**
   * The list of opening hours for Wednesday.
   */
  @observable
  @Type(() => OpeningHoursIntervalResponse)
  wednesday?: OpeningHoursIntervalResponse[];

  /**
   * The list of opening hours for Thursday.
   */
  @observable
  @Type(() => OpeningHoursIntervalResponse)
  thursday?: OpeningHoursIntervalResponse[];

  /**
   * The list of opening hours for Friday.
   */
  @observable
  @Type(() => OpeningHoursIntervalResponse)
  friday?: OpeningHoursIntervalResponse[];

  /**
   * The list of opening hours for Saturday.
   */
  @observable
  @Type(() => OpeningHoursIntervalResponse)
  saturday?: OpeningHoursIntervalResponse[];

  /**
   * The list of opening hours for Sunday.
   */
  @observable
  @Type(() => OpeningHoursIntervalResponse)
  sunday?: OpeningHoursIntervalResponse[];
}
